import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const root = css`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: stretch;
`;

export const title = css`
  font-size: 18px;
  font-weight: 800;
`;

export const collectionVisibilityDescription = css`
  background-color: ${theme.colors.peoople['azul-claro-medio']}1A;
  padding: 1.5rem;
  border-radius: 0%.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: 14px;
  font-weight: 300;
  b {
    font-weight: 600;
  }
`;
